import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { login, register } from '../utils/api';
import Register from '../components/auth/Register.js';
import Login from '../components/auth/Login.js';
import { Typography, Container, Box, Alert, Tab, Tabs, Paper, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AuthPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLogin, setIsLogin] = useState(searchParams.get('tab') !== 'register');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleTabChange = (_e, newValue) => {
    setIsLogin(newValue === 0);
    setError('');
  };

  const handleAuthSubmit = async (payload) => {
    setError('');
    setIsLoading(true);

    try {
      if (isLogin) {
        await login({
          identifier: payload.identifier,
          password: payload.password,
        });
      } else {
        await register({
          username: payload.username,
          email: payload.email,
          password: payload.password,
          dateOfBirth: payload.dateOfBirth,
          reason: payload.reason,
        });
      }

      window.location.assign('/app');
    } catch (err) {
      console.error('Auth error:', err.response || err);
      setError(
        err.response?.data?.message || 
        err.message ||
        `${isLogin ? 'Login' : 'Registration'} failed. Please try again.`
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: "url('/Ledgic_authPage_background.png')",
        display: 'grid',
        placeItems: 'center',
        px: 2,
      }}
    >
      <Box sx={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <IconButton
          onClick={() => navigate('/')}
          sx={{ position: 'absolute', left: 16, color: 'white' }}
          aria-label="Back to home"
        >
          <ArrowBackIcon />
        </IconButton>
        <Box
          onClick={() => navigate('/')}
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
        >
          <img
            src="/charcoal1_ledgic_symbpol.png"
            alt="Ledgic logo"
            style={{ width: 60, height: 'auto' }}
          />
          <Typography variant='h2'>
            {'Ledgic'}
          </Typography>
        </Box>
      </Box>
      <Box sx={{textAlign: 'center' }}>
          <Typography variant='h0' color='white'>
            {'Make money one less thing to stress about.'}
          </Typography>
      </Box>

      <Container maxWidth="sm" >
        <Paper sx={{ p: { xs: 3, sm: 4 } }}>

  {/*  Below is the actual login bow ABOVE is the aesthetucs*/}

          <Box sx={{ display: 'grid', gap: 2 }}>

            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h2" component="h1">
                {isLogin ? 'Welcome back' : 'Create your account'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {isLogin ? 'Sign in to your Ledgic account' : 'Start tracking your expenses intelligently'}
              </Typography>
            </Box>

            <Tabs
              value={isLogin ? 0 : 1}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{ mb: 1 }}
            >
              <Tab label="Login" />
              <Tab label="Register" />
            </Tabs>

            {error && <Alert severity="error">{error}</Alert>}

            {isLogin ? (
              <Login onSubmit={handleAuthSubmit} isLoading={isLoading} />
            ) : (
              <Register onSubmit={handleAuthSubmit} isLoading={isLoading} onCancel={() => navigate('/')} />
            )}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};


export default AuthPage;